var _excluded = ["svgRef", "title"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import React from "react";
var _ref2 =
/*#__PURE__*/
/*#__PURE__*/
React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("path", {
  d: "m95.073.19h220.602c25.723 0 46.575 20.852 46.575 46.575v145.871c0 25.723-20.852 46.575-46.575 46.575-2.963 0-5.918-.282-8.827-.844l-177.836-34.326a46.575 46.575 0 0 1 -34.66-29.058l-42.768-111.545c-9.207-24.018 2.798-50.953 26.816-60.161a46.575 46.575 0 0 1 16.673-3.087z",
  fill: "#ff4438"
}), /*#__PURE__*/React.createElement("path", {
  d: "m52.164 16.75h246.537c28.81 0 52.164 23.355 52.164 52.164v176.148c0 28.81-23.355 52.164-52.164 52.164-2.549 0-5.094-.186-7.615-.559l-246.537-36.381c-25.591-3.776-44.549-25.737-44.549-51.605v-139.767c0-28.81 23.355-52.164 52.164-52.164z",
  fill: "#003a70"
}));
var SvgTestimonyBg = function SvgTestimonyBg(_ref) {
  var svgRef = _ref.svgRef,
    title = _ref.title,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: 298,
    viewBox: "0 0 363 298",
    width: 363,
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};
var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgTestimonyBg, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/TestimonyBG.4b9973c8.svg";
export { ForwardRef as ReactComponent };